export const selectCamp = (state) => state.camp;
